import React from 'react';
import { useNavigate } from 'react-router-dom';
import QuestionFormBase from './QuestionFormBase';
import { createQuestion } from '../../../services/questionAPIService';
import { useAlert } from '../../../context/AlertContext';

const QuestionCreateForm = () => {
    const navigate = useNavigate();
    const { showAlert } = useAlert();

    const handleSubmit = async (formData) => {
        try {
            await createQuestion(formData);
            showAlert('Frage wurde erfolgreich erstellt', 'success', true);
            navigate('/admin');
        } catch (error) {
            console.error('Error creating question:', error);
            throw error;
        }
    };

    return (
        <QuestionFormBase
            onSubmit={handleSubmit}
            submitButtonText="Frage erstellen"
            title="Neue Frage erstellen"
        />
    );
};

export default QuestionCreateForm; 